const a = {
  "Wildberries (Вайлдберриз Банк)": "wb-bank",
  "АБ РОССИЯ": "abr",
  "Абсолют Банк": "absolutbank",
  Автоторгбанк: "avtotorgbank",
  "Авто Финанс Банк": "autofinancebank",
  "Азиатско-Тихоокеанский Банк": "atb",
  "Ак Барс Банк": "akbars",
  "АКБ Держава": "derzhava",
  "АКБ ЕВРОФИНАНС МОСНАРБАНК": "evrofinance",
  "АКБ Ланта Банк": "lanta",
  "АКБ СЛАВИЯ": "slaviabank",
  "АКБ Тендер Банк": "tenderbank",
  АКИБАНК: "akibank",
  "Алеф-Банк": "alefbank",
  Алмазэргиэнбанк: "albank",
  "Альфа-Банк": "alfabank",
  "Банк 131": "131",
  "Банк АВАНГАРД": "avangard",
  "Банк Аверс": "aversbank",
  "Банк Агророс": "agroros",
  "Банк Акцепт": "akcept",
  "Банк АЛЕКСАНДРОВСКИЙ": "alexbank",
  "Банк БЖФ": "bgfbank",
  "Банк ВБРР": "vbrr",
  "Банк Венец": "venets-bank",
  "Банк ДОМ.РФ": "domrfbank",
  "Банк Заречье": "zarech",
  "Банк ЗЕНИТ": "zenit",
  "Банк Интеза": "intesa",
  "Банк ИПБ": "ipb",
  "Банк ИТУРУП": "iturupbank",
  "Банк Кремлевский": "kremlinbank",
  "Банк Кузнецкий": "kuzbank",
  "Банк Левобережный": "slbank",
  "Банк Объединенный капитал": "okbank",
  "Банк Оранжевый": "orange",
  "Банк Приморье": "primbank",
  "Банк ПСКБ": "pskb",
  "банк Раунд": "round",
  "Банк Развитие-Столица": "dcapital",
  "Банк РЕСО Кредит": "resocredit",
  "Банк Русский Стандарт": "rsb",
  "Банк Санкт-Петербург": "bspb",
  "Банк Саратов": "banksaratov",
  "БАНК СГБ": "sbbank",
  "Банк Синара": "sinara",
  "БАНК СНГБ": "sngb",
  "Банк Снежинский": "snbank",
  "БАНК УРАЛСИБ": "uralsib",
  "Банк ФИНАМ": "finambank",
  "Банк Финсервис": "finbank",
  "Банк ЦентроКредит": "centrinvest",
  "Банк ЧБРР": "chbrr",
  "ББР Банк": "bbr",
  "БКС Банк": "bcs-bank",
  БыстроБанк: "bystrobank",
  ВЛАДБИЗНЕСБАНК: "vlbb",
  ВНЕШФИНБАНК: "vfbank",
  ВТБ: "vtb",
  Газпромбанк: "gazprombank",
  Газтрансбанк: "gaztransbank",
  Газэнергобанк: "gebank",
  ГЕНБАНК: "genbank",
  ГОРБАНК: "gorbank",
  "Дальневосточный банк": "dvbank",
  Датабанк: "databank",
  "Дом.ру (Урал ФД)": "uralfd",
  "Земский банк": "zemsky",
  Инбанк: "in-bank",
  "Инго Банк": "ingobank",
  ИШБАНК: "isbank",
  "КБ Долинск": "dolinsk",
  "КБ ЛОКО-Банк": "lockobank",
  "КБ Модульбанк": "modulbank",
  "КБ Москоммерцбанк": "moskb",
  "КБ Пойдём": "poidem",
  "КБ РостФинанс": "rostfinance",
  "КБ Стройлесбанк": "slbank",
  "КБ Хлынов": "hlynov",
  "КБ ЭНЕРГОТРАНСБАНК": "energotransbank",
  "КБЭР Банк Казани": "ofkazan",
  "Контур.Банк": "kontur-bank",
  "КОШЕЛЕВ-БАНК": "koshelev-bank",
  "Кошелек ЦУПИС (Мобильная карта)": "mcplat",
  "Кредит Европа Банк (Россия)": "crediteurope",
  "Кредит Урал Банк": "creditural",
  "Кубань Кредит": "kubank",
  Кузнецкбизнесбанк: "kbb",
  "МБ Банк": "mb-fs",
  "МЕЖДУНАРОДНЫЙ ФИНАНСОВЫЙ КЛУБ": "mfk-bank",
  Металлинвестбанк: "metallinvestbank",
  МЕТКОМБАНК: "metcom",
  "Мир Привилегий (МП Банк)": "mp-bank",
  "МКБ (Московский кредитный банк)": "mkb",
  "МОРСКОЙ БАНК": "maritimebank",
  МОСКОМБАНК: "moskb",
  "МС Банк Рус": "mspbank",
  "МТС-Банк": "mtsbank",
  "МТС Деньги (ЭКСИ Банк)": "exibank",
  Нацинвестпромбанк: "nipbank",
  "НБД-Банк": "nbdbank",
  "НИКО-БАНК": "nico-bank",
  "НКО ЭЛЕКСИР": "eleksir",
  Новобанк: "novobank",
  НОКССБАНК: "nokss",
  "Норвик Банк": "norvikbank",
  "НС Банк": "ns-bank",
  "Озон Банк (Ozon)": "ozon",
  "ОТП Банк": "otpbank",
  "Первый Дортрансбанк": "pervbank",
  "Первый Инвестиционный Банк": "invb",
  "Почта Банк": "pochtabank",
  "Прио-Внешторгбанк": "priovtb",
  ПроБанк: "probank",
  ПСБ: "psbank",
  "Райффайзен Банк": "raiffeisen",
  "Реалист Банк": "realistbank",
  "Ренессанс Банк (Ренессанс Кредит)": "rencredit",
  РосДорБанк: "rdb",
  Россельхозбанк: "rshb",
  "Роял Кредит Банк": "royal-bank",
  РУСНАРБАНК: "rusnarbank",
  Сбербанк: "sberbank",
  "СДМ-Банк": "sdm",
  "Северный Народный Банк": "sevnb",
  СИБСОЦБАНК: "sibsoc",
  "СИНКО-БАНК": "sinko-bank",
  "СКБ Примсоцбанк": "pscb",
  Совкомбанк: "sovcombank",
  "Солид Банк": "solidbank",
  "СОЦИУМ БАНК": "socium-bank",
  ТАТСОЦБАНК: "tatsotsbank",
  "Т-Банк": "tbank",
  "Тимер Банк": "timerbank",
  "ТКБ БАНК (ТРАНСКАПИТАЛБАНК)": "tkbbank",
  "Тойота Банк": "toyotafinance",
  Томскпромстройбанк: "tpsbank",
  "Точка Банк": "tochka",
  Трансстройбанк: "transstroybank",
  УБРиР: "ubrr",
  УРАЛПРОМБАНК: "uralprombank",
  "ФИНСТАР БАНК": "finbank",
  "ФОРА-БАНК": "forabank",
  Форштадт: "forshtadt",
  Хайс: "hicebank",
  "Центр-инвест": "centrinvest",
  "Цифра банк": "cifra",
  ЧЕЛИНДБАНК: "chelindbank",
  ЧЕЛЯБИНВЕСТБАНК: "chelinvest",
  Экспобанк: "expobank",
  ЭЛПЛАТ: "el-plat",
  Энергобанк: "energobank",
  "Эс-Би-Ай Банк": "sbibank",
  ЮМани: "yoomoney",
  "ЮниКредит Банк": "unicreditbank",
  "ЮНИСТРИМ БАНК": "unistream",
  Яндекс: "yandex",
  ЯРИНТЕРБАНК: "yarinterbank"
};
export {
  a as RU_BANK_SLUGS
};
